import { Lesson } from '@tdwb/core';

export interface TradingLessonsData {
  contextualLesson: Lesson;
  relatedLessons: Array<Lesson>;
}

export const LearnLinkIdMapping = {
  equity: 'stock',
  option: 'options',
  strategy: 'strategies',
  mutualfund: 'mutualFunds',
  gic: 'GICs',
  cash: 'betweenMyTDAccounts',
  ofi: 'fromOutsideTD',
  securities: 'securityTransfer',
  holdings: 'holdings'
};

export type DisplayLearnInformation = 'holdings' | 'transfers' | 'buysell';
